// Read as a full member expression so CRA can inline it at build time.

const DEBUG_ENVIRONMENTS = ["dev", "local"];

export const appEnvironment = () => process.env.REACT_APP_SENTRY_ENV || null;

// Fails closed: exact match only, no trimming and no case folding, so an
// unknown, missing or misspelt value keeps the console silent. Loosening this
// (e.g. "anything but prod") would print teacher data in production.
export const isAnalyticsDebugEnabled = () => DEBUG_ENVIRONMENTS.includes(appEnvironment());
